import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Loader2, Lock } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { adminLogin } from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await adminLogin(email, password);
      localStorage.setItem("vv_admin_token", data.access_token);
      toast.success("Welcome back, Admin.");
      navigate("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-obsidian radial-emerald noise grid place-items-center px-6">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="glass rounded-3xl p-8 md:p-10 w-full max-w-md gold-glow"
      >
        <img src="/assets/veda_logo_dark.png" alt="Veda Vitals" className="h-12 w-auto mb-8" />
        <div className="flex items-center gap-2 mb-1">
          <Lock className="h-4 w-4 text-gold" strokeWidth={1.5} />
          <p className="text-xs uppercase tracking-[0.25em] text-gold">Admin Access</p>
        </div>
        <h1 className="font-serif text-3xl text-white mb-8">Order Dashboard</h1>

        <form onSubmit={submit} className="space-y-5">
          <div className="grid gap-2">
            <Label htmlFor="al-email" className="text-vmuted">Email</Label>
            <Input id="al-email" data-testid="admin-email" type="email" value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="bg-white/5 border-white/10 focus-visible:ring-gold" placeholder="admin@vedavitals.in" />
          </div>
          <div className="grid gap-2">
            <Label htmlFor="al-pass" className="text-vmuted">Password</Label>
            <Input id="al-pass" data-testid="admin-password" type="password" value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="bg-white/5 border-white/10 focus-visible:ring-gold" placeholder="••••••••" />
          </div>
          <button
            type="submit"
            data-testid="admin-login-btn"
            disabled={loading}
            className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-gold px-8 py-3.5 text-obsidian font-medium hover:bg-gold-light transition-colors duration-300 disabled:opacity-60"
          >
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Sign In"}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
